<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs"/>
    <b-row>
      <b-col class="mb-3" md="4">
        <b-card :title="title">
          <b-form v-on:submit.prevent.stop="submit">
            <b-form-group id="team_label" label="Team" label-for="team">
              <b-form-select id="team" :options="teams" v-model="team">
                <template slot="first">
                  <option :value="null">All My Teams</option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group id="search_label" label="Search" label-for="search">
              <b-form-input id="search" type="text" v-model="search" />
            </b-form-group>
            <p class="text-right">
              <b-button to="/events" exact>Clear</b-button>
              <!-- <b-button type="submit" variant="primary">Update</b-button> -->
            </p>

            <b-alert variant="info" show>
              Searching by text only matches against <strong>whole words</strong>, and common short words like 'the' and 'a' are <strong>ignored</strong>.
            </b-alert>
          </b-form>
        </b-card>
      </b-col>
      <b-col class="mb-3" md="8">
        <b-card no-body>
          <div slot="header">
            {{headerText}}
          </div>
          <b-list-group class="mb-3" flush>
            <b-list-group-item v-for="event in events" :to="eventLink(event)" :key="event.id" class="align-items-start">
              <event-card :event="event"></event-card>
            </b-list-group-item>
          </b-list-group>
          <b-pagination-nav v-if="eventCount" align="center" size="md" :number-of-pages="pageCount" v-model="currentPage" :use-router="true" :limit="10" :link-gen="pageLink"></b-pagination-nav>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import API from '@/lib/api'
import EventCard from '@/components/EventCard'
import TeamPicker from '@/components/TeamPicker'
import debounce from 'debounce'

export default {
  name: 'Events',
  components: {
    'event-card': EventCard,
    'team-picker': TeamPicker
  },
  data () {
    return {
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: 'All Events', to: '/events', active: true}],
      events: [],
      currentPage: parseInt(this.$route.query.page || '1'),
      pageSize: 10,
      eventCount: null,
      teams: this.$store.getters.teams
        .map((team) => { return {text: team.name, value: team} }),
      team: this.$route.query.team_id != null ? this.$store.getters.teams.find((t) => { return t.id === parseInt(this.$route.query.team_id) }) : null,
      search: this.$route.query.search || '',
      search_params: {
        team_id: this.$route.query.team_id || '',
        search: this.$route.query.search
      }
    }
  },
  computed: {
    title () {
      if (this.team != null || this.search !== '') {
        return 'Searching Events'
      } else {
        return 'All Events'
      }
    },
    headerText () {
      if (this.eventCount === null) {
        return 'Loading...'
      } else if (this.eventCount === 0) {
        return 'No Events Found'
      } else if (this.eventCount === 1) {
        return '1 Event Found'
      } else {
        return `${this.eventCount} Events Found`
      }
    },
    pageCount () {
      if (this.eventCount != null) {
        return Math.ceil(this.eventCount / this.pageSize)
      } else {
        return null
      }
    }
  },
  created () {
    this.fetchEvents()
  },
  watch: {
    'currentPage' () {
      this.$router.push({ path: '/events', query: { page: this.currentPage, team_id: this.search_params['team_id'], search: this.search_params['search'] } })
    },
    'search' (oldSearch, newSearch) {
      this.submit()
    },
    'team' (oldTeam, newTeam) {
      if (oldTeam !== newTeam) {
        this.submit()
      }
    },
    '$route' (to, from) {
      this.currentPage = parseInt(to.query.page || '1')
      this.team = (this.$route.query.team_id != null && this.$route.query.team_id !== '') ? this.$store.getters.teams.find((t) => { return t.id === parseInt(this.$route.query.team_id) }) : null
      this.search = this.$route.query.search || ''
      this.search_params = {
        team_id: this.$route.query.team_id || '',
        search: this.$route.query.search
      }
      this.fetchEvents()
    }
  },
  methods: {
    fetchEvents () {
      var params = {
        context: 'all',
        pageSize: this.pageSize,
        page: this.currentPage
      }
      if (this.search_params['team_id'] != null && this.search_params['team_id'] !== '') {
        params['team_id'] = this.search_params['team_id']
      }
      if (this.search_params['search'] !== '') {
        params['search'] = this.search_params['search']
      }
      API.get('events', params, this.$store.getters.authHeaders)
        .then((response) => {
          this.eventCount = response.data.total_count
          this.events = response.data.events
        })
    },
    eventLink (event) {
      var teamId = null
      event.teams.forEach((team) => {
        if (teamId == null) {
          teamId = team.id
        }
        if (team.action_required) {
          teamId = team.id
        }
      })
      return {path: '/events/' + event.id, query: {team_id: teamId, context: 'events', return_to: this.$route.fullPath}}
    },
    submit: debounce(function (e) {
      var query = { page: 1, search: this.search }
      if (this.team != null) {
        query['team_id'] = this.team.id
      }
      this.$router.replace({path: '/events', query: query})
    }, 250),
    pageLink (page) {
      return {
        path: '/events',
        query: { page: page, team_id: this.search_params['team_id'], search: this.search_params['search'] }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Events.vue